import React, { FC } from "react";
import { Typography } from "@mui/material";
import { useTranslations } from "next-intl";

interface AppMockupSectionProps {}

const AppMockupSection: FC<AppMockupSectionProps> = () => {
  const t = useTranslations("");
  return (
    <div className="flex flex-wrap justify-between  pt-10 max-w-[1312px] w-full">
      <div className="flex-1 c-lg:min-w-[500px] max-w-[600px] px-4 flex flex-col c-lg:gap-8 gap-6 justify-center">
        <Typography
          variant="h4"
          className="font-bold c-lg:!text-[34px] !text-2xl leading-[52px] text-primary"
        >
      {t(`AppMockupHeading`)}
        </Typography>
        <Typography className="text-sm leading-5 text-primary">
              {t(`AppMockupDescription`)}

        </Typography>
      </div>

      <div className="flex c-lg:items-center items-start c-lg:gap-[100px] gap-5 c-lg:h-60 px-4 mt-6  md:mt-0  max-c-lg:min-w-full">
        <div className="flex flex-col items-start max-c-lg:justify-center gap-4 max-c-lg:w-full">
          <Typography variant="h6" className="font-semibold text-lg leading-7">
              {t(`availableNow`)}

          </Typography>
          <div className="flex flex-row items-center gap-4 ">
            <div className="flex flex-col max-c-lg:flex-row max-c-lg:flex-wrap max-c-lg:justify-center   gap-2">
              <img
                src="/images/footer/appStore.png"
                alt="App Store Download"
                className="h-10 object-contain "
              />
              <img
                src="/images/footer/googlePlay.png"
                alt="Google Play Download"
                className="h-10 object-contain "
              />
        
            </div>
            <div className="relative max-w-[91px] h-full max-c-lg:hidden">
              <img
                 src={"/images/qr.png"}
                alt="almuayed App Mockup"
                className="h-full object-contain"
              />
            </div>
          </div>
        </div>
        <div className="relative max-w-[230px] h-full max-c-lg:hidden">
          <img
            src="/images/footer/mockup.png"
            alt="almuayed App Mockup"
            className="h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default AppMockupSection;
